// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-section {
  background-color: #222;
  color: #fff;
  padding: 20px 0;
  text-align: center;
  overflow-x: hidden;
  overflow-y: hidden;
  min-height: 30vh;
}
.about-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 20px;
  gap: 20px;
}
.about-image {
  perspective: 1000px;
  opacity: 0;
  transform: translateX(-100px);
  transition: opacity 1.8s ease-out, transform 1.8s ease-out;
}
.animate .about-image {
  opacity: 1;
  transform: translateX(0);
}
.about-image img {
  width: 400px;
  height: 500px;
  object-fit: cover;
  margin-right: 100px;
  transition: transform 0.2s ease;
  transform-style: preserve-3d;
  filter: brightness(0.5);
}
.about-details {
  text-align: left;
  width: 50%;
  opacity: 0;
  transform: translateX(100px);
  transition: opacity 1.8s ease-out, transform 1.8s ease-out;
}
.animate .about-details {
  opacity: 1;
  transform: translateX(0);
}
.about-details h3 {
  font-size: 30px;
}
.about-details p {
  margin-bottom: 25px;
  font-size: 20px;
  line-height: 1.6;
}
.about-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  list-style: none;
  padding: 0;
}
.about-info li {
  margin-bottom: 10px;
  font-size: 20px;
  display: flex;
  align-items: center;
}
.about-info li a {
  color: white;
  font-size: 20px;
}
.about-info li::before {
  content: '•';
  color: #e74c3c;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: 0em;
}

@media (max-width: 1100px) {
  .about-image img {
    width: 250px;
    height: 350px;
  }
  .about-details {
    width: 70%;
  }
  .about-details h3 {
    font-size: 22px;
  }
  .about-details p {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 1.5;
  }
  .about-info li {
    margin-bottom: 8px;
    font-size: 18px;
  }
  .about-info li a {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .about-image {
    display: none;
  }
  .about-details {
    width: 100%;
  }
  .about-details h3 {
    font-size: 20px;
  }
  .about-details p {
    margin-bottom: 18px;
    font-size: 16px;
    line-height: 1.4;
  }
  .about-info {
    grid-template-columns: 1fr;
  }
  .about-info li {
    margin-bottom: 8px;
    font-size: 16px;
  }
  .about-info li a {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/About.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,0DAA0D;AAC5D;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,4BAA4B;EAC5B,0DAA0D;AAC5D;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".about-section {\n  background-color: #222;\n  color: #fff;\n  padding: 20px 0;\n  text-align: center;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  min-height: 30vh;\n}\n.about-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  padding: 20px;\n  gap: 20px;\n}\n.about-image {\n  perspective: 1000px;\n  opacity: 0;\n  transform: translateX(-100px);\n  transition: opacity 1.8s ease-out, transform 1.8s ease-out;\n}\n.animate .about-image {\n  opacity: 1;\n  transform: translateX(0);\n}\n.about-image img {\n  width: 400px;\n  height: 500px;\n  object-fit: cover;\n  margin-right: 100px;\n  transition: transform 0.2s ease;\n  transform-style: preserve-3d;\n  filter: brightness(0.5);\n}\n.about-details {\n  text-align: left;\n  width: 50%;\n  opacity: 0;\n  transform: translateX(100px);\n  transition: opacity 1.8s ease-out, transform 1.8s ease-out;\n}\n.animate .about-details {\n  opacity: 1;\n  transform: translateX(0);\n}\n.about-details h3 {\n  font-size: 30px;\n}\n.about-details p {\n  margin-bottom: 25px;\n  font-size: 20px;\n  line-height: 1.6;\n}\n.about-info {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n.about-info li {\n  margin-bottom: 10px;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n}\n.about-info li a {\n  color: white;\n  font-size: 20px;\n}\n.about-info li::before {\n  content: '•';\n  color: #e74c3c;\n  font-weight: bold;\n  display: inline-block;\n  width: 1em;\n  margin-left: 0em;\n}\n\n@media (max-width: 1100px) {\n  .about-image img {\n    width: 250px;\n    height: 350px;\n  }\n  .about-details {\n    width: 70%;\n  }\n  .about-details h3 {\n    font-size: 22px;\n  }\n  .about-details p {\n    margin-bottom: 20px;\n    font-size: 18px;\n    line-height: 1.5;\n  }\n  .about-info li {\n    margin-bottom: 8px;\n    font-size: 18px;\n  }\n  .about-info li a {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-image {\n    display: none;\n  }\n  .about-details {\n    width: 100%;\n  }\n  .about-details h3 {\n    font-size: 20px;\n  }\n  .about-details p {\n    margin-bottom: 18px;\n    font-size: 16px;\n    line-height: 1.4;\n  }\n  .about-info {\n    grid-template-columns: 1fr;\n  }\n  .about-info li {\n    margin-bottom: 8px;\n    font-size: 16px;\n  }\n  .about-info li a {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
